module.exports = __webpack_public_path__ + "static/img/douhao.f68b88ca.png";